import { Button } from '@material-ui/core';
import React from 'react';
import AddCircleIcon from '@material-ui/icons/AddCircle';

export type UploadButtonProps = {
    accept: string
    multiple?: boolean
    onFilesSelected: (fileList: FileList) => void
}

export function UploadButton ({ accept, multiple, onFilesSelected }: UploadButtonProps) {
    const inputRef = React.createRef<HTMLInputElement>();

    const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const fileList = e.target.files;

        if (fileList !== null) {
            onFilesSelected(fileList);
        }

        if (inputRef.current !== null) {
            inputRef.current.value = "";
        }

    }, [inputRef, onFilesSelected]);
    
    return (
        <label htmlFor="upload-button">
            <input 
                id="upload-button"
                ref={inputRef}
                type="file"
                accept={accept}
                multiple={multiple}
                onChange={handleChange}
                style={{display: 'none'}} 
            />

            <Button 
                startIcon={<AddCircleIcon />} 
                color="primary" 
                variant="contained" 
                component="span"
            >Escolher Arquivos</Button>
        </label>
    )
}